module.exports = __webpack_public_path__ + "assets/colored-e0654e.svg";